import MatterRolesCard from "@/components/features/settings/defaults/matter-roles/MatterRolesCard";
import { GlobalNotAuthorized } from "@/components/ui";
import { useUser } from "@/components/UserProvider";
import { PAGE_PERMISSION_KEYS } from "@/lib/data/static/permissionOptions";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_auth/settings/intake/roles")({
  component: RouteComponent,
});

function RouteComponent() {
  const { hasPagePermission } = useUser();

  if (!hasPagePermission(PAGE_PERMISSION_KEYS.intakeSettingsRoles)) {
    return <GlobalNotAuthorized />;
  }

  return (
    <MatterRolesCard title="Intake roles" addButtonLabel="Add intake role" />
  );
}
